import { customerTypes } from "../types";

const initState = {
  paymentMethodsLoading: false,
  paymentMethods: [],
  subscriptionsLoading: false,
  subscriptions: [],
};

export function customer(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case customerTypes.GET_PAYMENT_METHODS_REQUEST: {
      return { ...state, paymentMethodsLoading: true };
    }
    case customerTypes.GET_PAYMENT_METHODS_SUCCESS: {
      return { ...state, paymentMethodsLoading: false, paymentMethods: payload };
    }
    case customerTypes.GET_PAYMENT_METHODS_FAILURE: {
      return { ...state, paymentMethodsLoading: false, paymentMethods: [] };
    }

    case customerTypes.POST_PAYMENT_METHOD_REQUEST: {
      return { ...state, paymentMethodsLoading: true };
    }
    case customerTypes.POST_PAYMENT_METHOD_SUCCESS: {
      return { ...state, paymentMethodsLoading: false };
    }
    case customerTypes.POST_PAYMENT_METHOD_FAILURE: {
      return { ...state, paymentMethodsLoading: false };
    }

    case customerTypes.GET_SUBSCRIPTIONS_REQUEST: {
      return { ...state, subscriptionsLoading: true };
    }
    case customerTypes.GET_SUBSCRIPTIONS_SUCCESS: {
      return { ...state, subscriptionsLoading: false, subscriptions: payload };
    }
    case customerTypes.GET_SUBSCRIPTIONS_FAILURE: {
      return { ...state, subscriptionsLoading: false, subscriptions: [] };
    }

    case customerTypes.CANCEL_SUBSCRIPTION_REQUEST: {
      return { ...state, subscriptionsLoading: true };
    }
    case customerTypes.CANCEL_SUBSCRIPTION_SUCCESS: {
      return { ...state, subscriptionsLoading: false, subscriptions: payload };
    }
    case customerTypes.CANCEL_SUBSCRIPTION_FAILURE: {
      return { ...state, subscriptionsLoading: false };
    }

    default:
      return state;
  }
}
